export default {
  title: 'Attributi dietetici',
};
